"use strict";
/**
 * A trimmed-down version npmjs.org/classnames.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var compileClassnames = function (classes) {
    var classList = [];
    for (var key in classes) {
        // istanbul ignore if
        if (!Object.prototype.hasOwnProperty.call(classes, key)) {
            continue;
        }
        if (classes[key]) {
            classList.push(key.trim());
        }
    }
    return classList.join(' ');
};
exports.default = compileClassnames;
//# sourceMappingURL=classes.js.map